
<template>

	<min_age ref_type="buildings"/>

</template>

<script>

import min_age from "./base"

export default
{
	components :
	{
		min_age
	}
}

</script>

